import React, { useState, useEffect } from 'react'

function FlightServices() {
    const [services, setServices] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        const fetchServices = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/flight-services/`)
                if (!response.ok) {
                    throw new Error('Failed to fetch services')
                }
                const data = await response.json()
                setServices(data.results || [])
                setLoading(false)
            } catch (err) {
                setError(err.message)
                setLoading(false)
            }
        }

        fetchServices()
    }, [])

    if (loading) {
        return (
            <section className="flight-services-section py-5">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }

    if (error || services.length === 0) {
        return (
            <section className="flight-services-section py-5">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center">
                            <h2 className="section-title mb-4">Our Flight Services</h2>
                            <p className="text-muted">No services available at the moment.</p>
                        </div>
                    </div>
                </div>
            </section>
        )
    }

    return (
        <section className="flight-services-section py-5">
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center mb-5">
                        <h2 className="section-title mb-4">Our Flight Services</h2>
                        <p className="section-subtitle">Experience exceptional service with every flight booking</p>
                    </div>
                </div>
                <div className="row">
                    {services.map((service) => (
                        <div key={service.id} className="col-lg-4 col-md-6 mb-4">
                            <div className="service-card card border-0 shadow-sm h-100 text-center">
                                <div className="card-body p-4">
                                    <div className="service-icon mb-4">
                                        {service.icon ? (
                                            <img 
                                                src={service.icon} 
                                                alt={service.title}
                                                style={{ width: '60px', height: '60px' }}
                                                className="mx-auto d-block"
                                            />
                                        ) : (
                                            <div className="icon-wrapper bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto" 
                                                 style={{ width: '80px', height: '80px' }}>
                                                <i className="fas fa-plane fs-2"></i>
                                            </div>
                                        )}
                                    </div>
                                    <h5 className="card-title mb-3">{service.title}</h5>
                                    <p className="card-text text-muted mb-4">{service.description}</p>
                                    {service.features && service.features.length > 0 && (
                                        <ul className="list-unstyled text-start">
                                            {service.features.map((feature, index) => (
                                                <li key={index} className="mb-2">
                                                    <i className="fas fa-check text-success me-2"></i>
                                                    {feature}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                    {service.price && (
                                        <div className="service-price mt-3">
                                            <span className="text-primary fw-bold fs-5">
                                                {service.price_type === 'free' ? 'Free' : `$${service.price}`}
                                            </span>
                                            {service.price_type !== 'free' && (
                                                <small className="text-muted d-block">per booking</small>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                
                {/* Stats Section */}
                <div className="row mt-5 pt-5 border-top">
                    <div className="col-12">
                        <div className="stats-section">
                            <div className="row text-center">
                                <div className="col-lg-3 col-md-6 mb-4">
                                    <div className="stat-item">
                                        <div className="stat-number text-primary fw-bold display-4">500+</div>
                                        <div className="stat-label text-muted">Airlines</div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 mb-4">
                                    <div className="stat-item">
                                        <div className="stat-number text-primary fw-bold display-4">1000+</div>
                                        <div className="stat-label text-muted">Destinations</div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 mb-4">
                                    <div className="stat-item">
                                        <div className="stat-number text-primary fw-bold display-4">1M+</div>
                                        <div className="stat-label text-muted">Happy Travelers</div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 mb-4">
                                    <div className="stat-item">
                                        <div className="stat-number text-primary fw-bold display-4">24/7</div>
                                        <div className="stat-label text-muted">Customer Support</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FlightServices
